import { formatCurrency } from '@/common/utils/formatters'
import ProposalAwareResumeItem from '@/features/maintenance/features/workflows/pages/Show/components/tabs/ForwardingsTab/sections/DirectiveEntry/entries/ExecutionEntry/content/ExecutionEntryDiagnostic/ProposalAwareResumeItem'
import { ReactNode } from 'react'

interface ProposalAwareValuesRowProps {
  originalUnitPrice: number
  unitPriceLabel?: string | null;
  displayNewUnitPrice: number | null
  unitPricePercentage: string | null
  originalTotalValue: number
  displayNewTotalValue: number | null
  totalValuePercentage: string | null
  originalWarranty: number
  displayNewWarranty: number | null
  quantityDisplay: ReactNode
}

const ProposalAwareValuesRow = ({
  originalUnitPrice,
  unitPriceLabel,
  displayNewUnitPrice,
  unitPricePercentage,
  originalTotalValue,
  displayNewTotalValue,
  totalValuePercentage,
  originalWarranty,
  displayNewWarranty,
  quantityDisplay,
}: ProposalAwareValuesRowProps) => {
  return (
    <div className="flex items-center flex-wrap gap-3">
      <ProposalAwareResumeItem
        label={unitPriceLabel ?? "Valor unitário"}
        originalValue={originalUnitPrice}
        newValue={displayNewUnitPrice}
        differencePercentage={unitPricePercentage}
        format={formatCurrency}
      />

      <p className="text-sm">x</p>

      {quantityDisplay}

      <p className="text-sm">=</p>

      <ProposalAwareResumeItem
        label="Valor total"
        originalValue={originalTotalValue}
        newValue={displayNewTotalValue}
        differencePercentage={totalValuePercentage}
        format={formatCurrency}
      />

      <ProposalAwareResumeItem
        label="Garantia em dias"
        originalValue={originalWarranty}
        newValue={displayNewWarranty}
        format={(value) => `${value} dias`}
        higherIsBetter
      />
    </div>
  )
}

export default ProposalAwareValuesRow
